import React from 'react';

import SearchTeaser from '../../../components/SearchTeaser';
import ArticleTeaser from './Teaser';
import ArticleDetail from './Detail';

const NodeArticle = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'search_teaser':
      return <SearchTeaser entity={entity} />;
    case 'teaser':
      return <ArticleTeaser entity={entity} />;
    case 'full':
    default:
      return <ArticleDetail entity={entity} />;
  }
};

export default NodeArticle;
